var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dirty)?_c('div',[(_vm.hasError('required'))?_c('small',{staticClass:"invalid-feedback",domProps:{"innerHTML":_vm._s(_vm.$t('common.form.error.required'))}}):_vm._e(),(_vm.hasError('email'))?_c('small',{staticClass:"invalid-feedback",domProps:{"innerHTML":_vm._s(_vm.$t('common.form.error.email'))}}):_vm._e(),(_vm.hasError('minLength'))?_c('small',{staticClass:"invalid-feedback",domProps:{"innerHTML":_vm._s(
      _vm.$t('common.form.error.minLength', {
        min: _vm.getError('minLength').value,
        value: _vm.model.length,
      })
    )}}):_vm._e(),(_vm.hasError('maxLength'))?_c('small',{staticClass:"invalid-feedback",domProps:{"innerHTML":_vm._s(
      _vm.$t('common.form.error.maxLength', {
        max: _vm.getError('maxLength').value,
        value: _vm.model.length,
      })
    )}}):_vm._e(),(_vm.hasError('sameAs'))?_c('small',{staticClass:"invalid-feedback",domProps:{"innerHTML":_vm._s(
      _vm.$t('common.form.error.sameAs', {
        control: _vm.$t('common.form.error.controls.' + _vm.getError('sameAs').value),
      })
    )}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }